export default class FetchHelper {
    static getOptions = () => {
        return {
            method: 'GET'
        };
    }

    static postOptions(body) {
        return {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
    }

    static putOptions(body) {
        return {
            method: 'PUT',
            body: JSON.stringify(body),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
    }

    static post(url, body) {
        return fetch(url, FetchHelper.postOptions(body))
            .then((response) => {
                if (response.ok) { return response.status === 200 ? response.json() : {}; }
                
                const err = `${response.status} ${response.statusText}`;
                console.error(err);
                return Promise.reject(err);
            });
    }

    static put(url, body) {
        return fetch(url, FetchHelper.putOptions(body))
            .then((response) => {
                if (response.ok) { return response.status === 200 ? response.json() : {}; }
                
                const err = `${response.status} ${response.statusText}`;
                console.error(err);
                return Promise.reject(err);
            });
    }

    static get(url) {
        return fetch(url, FetchHelper.getOptions())
        .then((response) => {
            if (response.ok) { return response.status === 200 ? response.json() : {}; }
            
            const err = `${response.status} ${response.statusText}`;
            console.error(err);
            return Promise.reject(err);
        });
    }

    static del(url) {
        return fetch(url, { method: 'DELETE' })
            .then((response) => {
                if (response.ok) { return response.status === 200 ? response.json() : {}; }

                const err = `${response.status} ${response.statusText}`;
                console.error(err);
                return Promise.reject(err);
            });
    }

    static postFormData(url, formData) {
        return fetch(url, {
            method: 'POST',
            body: formData
        })
        .then((response) => {
            if (response.ok) { return response.json(); }
            
            const err = `${response.status} ${response.statusText}`;
            console.error(err);
            return Promise.reject(err);
        });
    }
}